export const SHOW_YAML_IMPORT = 'SHOW_YAML_IMPORT';
export const SET_YAML_FILE_LIST = 'SET_YAML_FILE_LIST';
export const SET_SELECTED_YAML_FILE = 'SET_SELECTED_YAML_FILE';
export const SET_IS_FIRST_TIME_YAML_IMPORT = 'SET_IS_FIRST_TIME_YAML_IMPORT';
export const RESET_HYP_YAML_IMPORT = 'RESET_HYP_YAML_IMPORT';

export const resetYamlImport = () => {
  return {
    type: RESET_HYP_YAML_IMPORT,
  };
};

export const setIsFirstTimeYamlImport = (payload: boolean) => {
  return {
    type: SET_IS_FIRST_TIME_YAML_IMPORT,
    payload,
  };
};

export const setShowYamlImport = (payload: boolean) => {
  return {
    type: SHOW_YAML_IMPORT,
    payload,
  };
};

export const setYamlFileList = (payload: any) => {
  return {
    type: SET_YAML_FILE_LIST,
    payload,
  };
};

export const setSelectedYamlFile = (payload: any) => {
  return {
    type: SET_SELECTED_YAML_FILE,
    payload,
  };
};
